import { render, staticRenderFns } from "./GolstatsData.vue?vue&type=template&id=3cd07058&scoped=true&"
import script from "./GolstatsData.vue?vue&type=script&lang=js&"
export * from "./GolstatsData.vue?vue&type=script&lang=js&"
import style0 from "./GolstatsData.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GolstatsData.vue?vue&type=style&index=1&id=3cd07058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd07058",
  null
  
)

export default component.exports